import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, FormControl, MenuItem, Pagination, Select, Skeleton, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import dayjs from 'dayjs'
import StockContext from './services/stockApi'
import { useSelector } from 'react-redux'
import { getData } from '../../services/api'
import { STOCK_CONFIG } from './config'
import './stockAdjust.scss'
export default function StockAdjust() {
    const { profile } = useSelector(state => state.profile)

    // const { getAdjustsList } = useContext(StockContext);
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let b = searchParams.get('b') || ''
    let id = searchParams.get('id') || ''
    let page = searchParams.get('page') || '1'
    const [data, setData] = useState([])
    const [branchs, setBranchs] = useState([])
    const [adjustNo, setAdjustNo] = useState('')
    // const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);

    // const getData = async () => {
    //     const res = await api.get(`stock/adjusts?adjustNo=${adjustNo}&branchNo=${branchsNo === 'all' ? '' : branchsNo}`)
    //     const data = await res.data.result
    //     if (res.data.status === true) {
    //         setData(data)
    //     }
    // }
    const getBranchs = async () => {
        await getData('dbms/branchs').then((response) => {
            if (response.status === true) {
                setBranchs(response.result)
            }
        })
    }

    const getAdjustsList = async () => {
        setLoading(true)
        let _params = `${q ? '&q=' + q : ''}${b ? b !== 'all' ? '&branchNo=' + b : '' : ''}`

        await getData(STOCK_CONFIG.requests.getAdjusts.url + `?page=${page}&limit=${rowsPerPage}`, _params).then((response) => {
            if (response.status === true) {
                setData(response.result)
                setLoading(false)
            }
        })
    }
    useEffect(() => {
        getBranchs()
    }, [])
    useEffect(() => {
        getAdjustsList()
    }, [q, b, page])
    return (
        <Page>
            <div class="container-fluid">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '20px 0px' }}>
                    <div class="col-lg-4 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการปรับปรุงยอด
                        </label>
                    </div>
                    <div class="col-lg-8 col-md-12 text-left " style={{display:'flex', justifyContent:'end'}}>
                         <div class="col-lg-3 col-md-12 text-end px-4">
                        <Link to={`/stock/stock-adjust/add`}>
                            <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                        </Link>

                    </div>
                    {profile?.BranchNo?.BranchNo === '00' &&

                        <div class="col-lg-2 col-md-12 ">

                            <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                <FormControl variant="standard" fullWidth >
                                    <Select value={b || 'all'} onChange={e => setSearchParams({ q: q, b: e.target.value })} 
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                    >
                                        <MenuItem value='all'>ทั้งหมด</MenuItem>

                                        {branchs?.map((x, i) => (
                                            <MenuItem value={x?.BranchNo}>{x?.Province}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </div >}
                    <div class="col-lg-3 col-md-12">
                        <Box className='backgroundField'>
                            <TextField value={q} onChange={e => setSearchParams({ q: e.target.value, b: b })} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>
                    </div>
                    </div>
                   
                </div >

                <div class="stockAdjust row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover  ">
                            <thead>
                                <tr>
                                    <th class="text-center">ที่</th>
                                    <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                    <th class="text-center">วันที่เอกสาร</th>
                                    <th class="text-center">เลขที่เอกสาร</th>
                                    <th class="text-center"> รายการ</th>
                                    <th class="text-center">ผู้ทำรายการ</th>
                                    <th class="text-center">สถานะ</th>
                                    <th class="text-center">ดำเนินการ</th>
                                </tr>
                            </thead>
                            <tbody class="cp">
                                {data?.items?.map((x, i) => (
                                    <tr className={id === x?.AdjustNo ? 'active' : ''}>
                                        <td class="text-center">{(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                        <td class="text-center">{x?.BranchNo?.BranchName}</td>
                                        <td class="text-center">{dayjs(x?.CreateDate).format('DD/MM/BBBB')}</td>
                                        <td class="text-center">{x?.AdjustNo}</td>
                                        <td class="text-center">{x?.IsAddedType ? 'ปรับปรุงเข้า' : 'ปรับปรุงออก'}</td>
                                        <td class="text-center">{x?.ModifiedId}</td>
                                        <td class="text-center">
                                            {x?.Status === 'D' ?
                                                <span class="status-draft">
                                                    บันทึกร่าง
                                                </span> : x?.Status === 'W' ?
                                                    <span class="status-wait">
                                                        รออนุมัติ
                                                    </span> : x?.Status === 'Y' ?
                                                        <span class="status-active">
                                                            เสร็จสิ้น
                                                        </span> : x?.Status === 'N' ?
                                                            <span class="status-inactive">
                                                                ยกเลิก
                                                            </span> : ''
                                            }

                                        </td>
                                        <td class="text-center">
                                            <Link to={`/stock/stock-adjust/${x.AdjustNo}`} onClick={() => setSearchParams({ id: x?.AdjustNo, page: page, q: q, b: b, })}>
                                                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                                            </Link>
                                        </td >
                                    </tr >
                                ))}


                            </tbody >
                        </table >
                    </div >}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q, b: b, id: id })} shape="rounded" />
                    </div >
                </div >
            </div >
        </Page >
    )
}
